export default {
  label: 'Number',
  placeholder: '',
  description: '',
  tooltip: '',
  customClass: '',
  hidden: false,
  hideLabel: false,
  disabled: false,
  decimalLimit: 3,
  key: 'number',
  defaultValue: {
    type: 'value',
    value: ''
  },
  validate: {
    required: false
  },
  type: 'number',
  input: true,
  isNew: true,
  amsField: ''
};
